import { render, staticRenderFns } from "./edit-attendee-data.vue?vue&type=template&id=880f53de&scoped=true"
import script from "./edit-attendee-data.vue?vue&type=script&lang=js"
export * from "./edit-attendee-data.vue?vue&type=script&lang=js"
import style0 from "./edit-attendee-data.vue?vue&type=style&index=0&id=880f53de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880f53de",
  null
  
)

export default component.exports